module.exports = __webpack_public_path__ + "static/media/combat(17).49828f6c.PNG";